import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import postsReducer from './slices/postsSlice';
import notificationsReducer from './slices/notificationsSlice';
import categoriesReducer from './slices/categoriesSlice';
import usersReducer from './slices/usersSlice';
import alumniReducer from './slices/alumniSlice';
import newsletterReducer from './slices/newsletterSlice';
import sentEmailReducer from './slices/sentEmailSlice';
import announcementEventReducer from './slices/announcementEventSlice';
import partnershipReducer from './slices/partnershipSlice';
import publicReducer from './slices/publicSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    posts: postsReducer,
    notifications: notificationsReducer,
    categories: categoriesReducer,
    users: usersReducer,
    alumni: alumniReducer,
    newsletter: newsletterReducer,
    sentEmail: sentEmailReducer,
    announcementEvent: announcementEventReducer,
    partnership: partnershipReducer,
    public: publicReducer,
  },
});
